module.exports = __webpack_public_path__ + "img/ab-loading.b66ea020.jpg";